import React from "react";

function UserIcon() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#wvptz4rs2a)" fill="#637590">
                <path
                    opacity=".3"
                    d="M8 7.333A2.667 2.667 0 1 1 8 2a2.667 2.667 0 0 1 0 5.333z"
                />
                <path d="M2 13.466c.259-3.182 2.841-4.8 5.989-4.8 3.192 0 5.814 1.53 6.01 4.8.007.131 0 .534-.501.534H2.485c-.167 0-.499-.36-.485-.534z" />
            </g>
            <defs>
                <clipPath id="wvptz4rs2a">
                    <path fill="#fff" d="M0 0h16v16H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default UserIcon;
